module.exports = __webpack_public_path__ + "img/p2-img2-d2-2.b02796f1.png";